import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
// import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import logo from "assets/img/boxlogo.png";
import adminService from "services/admin.service";

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Powered by '}
      <Link color="inherit" href="https://nobugs.com.br" target="_blank">
        No Bugs
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100vh',
  },
  image: {
    backgroundImage: 'url(https://source.unsplash.com/user/windows)',
    backgroundRepeat: 'no-repeat',
    backgroundColor:
      theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  paper: {
    margin: theme.spacing(8, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  // logo: {
  //   position: "relative",
  //   padding: "20px 20px",
  //   "&:after": {
  //     content: '""',
  //     position: "absolute",
  //     bottom: "0",

  //     right: "15px",
  //     width: "calc(100% - 30px)",
  //   }
  // },
  // logoImage: {
  //   width: "0px",
  //   display: "inline-block",
  //   maxHeight: "30px",
  //   marginLeft: "10px",
  //   marginRight: "15px"
  // },
  // img: {
  //   width: "60px",
  //   top: "1px",
  //   position: "absolute",
  //   verticalAlign: "middle",
  //   border: "0"
  // },
  logo: {
    display:'flex',
    justifyContent:'center', /* horizontally center */
    alignItems:'center',    /* vertically center */
    height:'200px',
    width:'300px',
  },
  img: {
    maxWidth:'100%',
    maxHeight:'100%'
  }
}));

export default function SignInSide() {
  const classes = useStyles();
  const [user, setUser] = useState(''); 
  const [password, setPassword] = useState(''); 
  const [error, setError] = useState(''); 

  const handleSubmit = async () => {
    try{
      setError('');
      const login = await adminService.signIn({user: user, password: password})
      if(login.status === 200){
        document.cookie=`_control_cookie=${login.data.control};path=/`;
        document.location.reload();
      }
    } catch(error){
      if(!!error.response && error.response.status === 401)
        setError('O usuário e a senha fornecidos não correspondem às informações em nossos registros. Verifique-as e tente novamente.');
      else
      console.error("Ocorreu um erro ao realizar login: ", error)
    }
  }

  return (
    <Grid container component="main" className={classes.root}>
      <CssBaseline />
      <Grid item xs={false} sm={4} md={7} className={classes.image} />
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <div className={classes.paper}>
            <div className={classes.logo}>
                <img src={logo} alt="logo" className={classes.img} />
            </div>
          <form className={classes.form} noValidate>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="user"
              label="Usuário"
              name="user"
              autoComplete="user"
              autoFocus
              onChange={(event) => setUser(event.target.value)}
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password"
              label="Senha"
              type="password"
              id="password"
              autoComplete="current-password"
              onChange={(event) => setPassword(event.target.value)}
            />
            {/* <FormControlLabel
              control={<Checkbox value="remember" color="primary" />}
              label="Lembrar de mim"
            /> */}
            <Typography component="h1" color='error'>
              {error}
            </Typography>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
              onClick={(event) => {handleSubmit(event)}}
              disabled={(user.length < 3 && password.length < 3) ? true : false}
            >
              Entrar
            </Button>
            {/* <Grid container>
              <Grid item xs>
                <Link href="#" variant="body2">
                  Forgot password?
                </Link>
              </Grid>
              <Grid item>
                <Link href="#" variant="body2">
                  {"Don't have an account? Sign Up"}
                </Link>
              </Grid>
            </Grid> */}
            <Box mt={5}>
              <Copyright />
            </Box>
          </form>
        </div>
      </Grid>
    </Grid>
  );
}